import * as React from 'react';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';

import { ChartScheduleProgress, ChartTotalScans, ChartTotalSubscribers } from 'components';
import { useDashboardPageContext } from './dashboard-page.context';
import { DashboardDateRangePicker } from './dashboard-date-range-picker';

interface DashboardMetricCardsProps {}

export const DashboardMetricCards: React.FC<DashboardMetricCardsProps> = () => {
  const theme = useTheme();
  const up_md = useMediaQuery(theme.breakpoints.up('md'));
  const down_xl = useMediaQuery(theme.breakpoints.down('xl'));
  const { buildingId, start, end } = useDashboardPageContext();

  const gridItemStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  };

  return buildingId && start && end ? (
    <>
      <Box sx={{ paddingBottom: 4, width: up_md && down_xl ? 'calc(100% - 30px - 24px)' : 'fit-content' }}>
        <DashboardDateRangePicker start={start} end={end} />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={6} xl={3} sx={gridItemStyle}>
          <ChartTotalScans buildingId={buildingId} start={start} end={end} />
        </Grid>

        <Grid item xs={12} md={12} lg={6} xl={3} sx={gridItemStyle}>
          <ChartTotalSubscribers buildingId={buildingId} />
        </Grid>

        <Grid item xs={12} md={12} lg={12} xl={6} sx={gridItemStyle}>
          <ChartScheduleProgress buildingId={buildingId} />
        </Grid>
      </Grid>
    </>
  ) : null;
};
